import PropTypes from 'react-proptypes';
import ToolLogoSvg from 'images/hns/logo.svg';

export default {
  app: 'hns',
  logo: ToolLogoSvg,
  framed: false,
  pages: [
    'landing',
    'mortgage',
    'results',
  ],
  page_icons: { results: '/images/hns/calculator.svg' },
  syncing: false,
  broken: false,
  recalculating: null,
  settings: null,
  input: {
    // landing
    applicant_dob: {
      day: '',
      month: '',
      year: '',
      value: '',
    },
    applicant_has_partner: false,
    partner_dob: {
      day: '',
      month: '',
      year: '',
      value: '',
    },

    // mortgage
    mortgage_provider: null, // mortgage_provider id
    interest_only_mortgage_debt: null, // number
    mortgage_end_date: {
      day: '',
      month: '',
      year: '',
      value: '',
    },
    home_value: null,

    // income
    applicant_income: null,
    applicant_income_period: 'monthly',
    applicant_holiday_bonus: true,
    applicant_13th_month_salary: false,
    applicant_pension_income: null,
    applicant_pension_income_period: 'yearly',
    partner_income: null,
    partner_income_period: 'monthly',
    partner_holiday_bonus: true,
    partner_13th_month_salary: false,
    partner_pension_income: null,
    partner_pension_income_period: 'yearly',

    // savings
    has_own_resources: false,
    own_resources: null,
    has_potential_resources: false,
    potential_resources: null,
    unknown_potential_resources: false,
    potential_living_expenses_reduction: false,

    // client-side only
    info_box: null,
    tab: null,
    show_disclaimer: false,
    next_step_text: null,
    active_card: null,
  },
  output: {
    errors: {},
    applicant_income: null,
    applicant_pension_income: null,
    applicant_show_income: false,
    applicant_show_aow: false,
    partner_income: null,
    partner_show_income: false,
    partner_show_aow: false,
    partner_pension_income: null,
    partner_aow: false,
    loan_to_value: null,
    mortgage_duration: null,
    applicant_age: null,
    percentage_of_max_mortgage: null,
    score: 8,
  },
};

const {
  string,
  number,
  bool,
  shape,
  instanceOf,
} = PropTypes;

export const shapeSettings = shape({
  leadButtonUrl: string,
  leadButtonText: string,
  showLeadButton: bool,
  leadFormHeader: string,
  leadFormText: string,
  enablePdf: bool,
  enablePremiumCalculation: bool,
  enableHypotheekbondLogo: bool,
  ngh_max_loan: number,
  regulations: shape({ reference_interest_rate: number }),
});

export const date = shape({
  day: string,
  month: string,
  year: string,
  value: string,
});

export const shapeInput = shape({
  applicant_dob: date,
  applicant_has_partner: bool,
  partner_dob: date,
  mortgage_provider: shape({}),
  interest_only_mortgage_debt: number,
  mortgage_end_date: date,
  home_value: number,
  applicant_income: number,
  applicant_income_period: string,
  applicant_holiday_bonus: bool,
  applicant_13th_month_salary: bool,
  applicant_pension_income: number,
  applicant_pension_income_period: string,
  partner_income: number,
  partner_income_period: string,
  partner_holiday_bonus: bool,
  partner_13th_month_salary: bool,
  partner_pension_income: number,
  partner_pension_income_period: string,
  has_own_resources: bool,
  own_resources: number,
  has_potential_resources: bool,
  potential_resources: number,
  unknown_potential_resources: bool,
  potential_living_expenses_reduction: bool,
  info_box: string,
  show_disclaimer: bool,
  active_card: string,
});

export const shapeOutput = shape({
  errors: shape({}),
  mortgage_providers: instanceOf(Array),
  applicant_income: number,
  applicant_show_income: bool,
  applicant_show_aow: bool,
  applicant_pension_income: number,
  partner_income: number,
  partner_show_income: bool,
  partner_show_aow: bool,
  partner_pension_income: number,
  loan_to_value: shape(),
  mortgage_duration: shape(),
  applicant_age: shape(),
  percentage_of_max_mortgage: shape(),
  score: number,
});
